import { render, staticRenderFns } from "./TgsHomepageSponsor.vue?vue&type=template&id=157cb433&scoped=true&"
import script from "./TgsHomepageSponsor.vue?vue&type=script&lang=js&"
export * from "./TgsHomepageSponsor.vue?vue&type=script&lang=js&"
import style0 from "./TgsHomepageSponsor.vue?vue&type=style&index=0&id=157cb433&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157cb433",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VImg,VProgressCircular,VRow,VSpacer})
